import { DataLayer } from "@upthrust/datalayer";

const selectors: Record<"dataGtm" | "button", string> = {
  dataGtm: "[data-gtm]",
  button: ".yith-wcwl-icon.fa.fa-heart-o",
};

function init() {
  const buttons = Array.from(document.querySelectorAll(selectors.button));

  buttons.forEach((button) =>
    button.addEventListener("click", (e) => {
      // @ts-ignore
      const gtmElement = e.target.closest(selectors.dataGtm) as HTMLElement;

      if (gtmElement) {
        const data = JSON.parse(atob(gtmElement.getAttribute("data-gtm") || "")) || {};

        DataLayer.pushEvent("add_to_wishlist", data);
      }
    })
  );
}

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
